import React from "react";
import "./FeaturesSection.css";

import {
  FaShippingFast,
  FaSchool,
  FaBuilding,
  FaAward,
} from "react-icons/fa";

const features = [
  {
    icon: <FaShippingFast />,
    title: "Fast Delivery",
    text: "Quick and reliable delivery for schools, offices, and businesses.",
  },
  {
    icon: <FaSchool />,
    title: "Educational Essentials",
    text: "Quality products for students, teachers, and learning spaces.",
  },
  {
    icon: <FaBuilding />,
    title: "Office Supplies",
    text: "Everything your workplace needs to stay organized and productive.",
  },
  {
    icon: <FaAward />,
    title: "Trusted Quality",
    text: "Carefully selected products with great value and dependable service.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="features-section">
      <div className="features-container">

        {features.map((feature, index) => (
          <div className="feature-card" key={index}>

            <div className="feature-icon">
              {feature.icon}
            </div>

            <h3>{feature.title}</h3>

            <p>{feature.text}</p>

          </div>
        ))}

      </div>
    </section>
  );
};

export default FeaturesSection;